import CssBaseline from '@mui/material/CssBaseline'
import { createStyles, withStyles } from '@mui/styles'
import React from 'react'
import FreightBigPro from './../fonts/FreightBigPro.woff2'
import FreightBigProBold from './../fonts/FreightBigProBold.woff2'
import FuturaPt from './../fonts/FuturaPt.woff2'
import FuturaPtMedium from './../fonts/FuturaPtMedium.woff2'
import JostLight from './../fonts/jost/Jost-Light.ttf'
import JostRegular from './../fonts/jost/Jost-Regular.ttf'
import JostMedium from './../fonts/jost/Jost-Medium.ttf'
import JostSemiBold from './../fonts/jost/Jost-SemiBold.ttf'
import JostBold from './../fonts/jost/Jost-Bold.ttf'
import MerriweatherRegular from './../fonts/Merriweather-Regular.ttf'
import MerriweatherBold from './../fonts/Merriweather-Bold.ttf'

const JOST_FONT = [
  {
    fontFamily: 'Jost',
    fontStyle: 'normal',
    fontDisplay: 'swap',
    fontWeight: 300,
    src: `url(${JostLight}) format('truetype')`,
  },
  {
    fontFamily: 'Jost',
    fontStyle: 'normal',
    fontDisplay: 'swap',
    fontWeight: 400,
    src: `url(${JostRegular}) format('truetype')`,
  },
  {
    fontFamily: 'Jost',
    fontStyle: 'normal',
    fontDisplay: 'swap',
    fontWeight: 500,
    src: `url(${JostMedium}) format('truetype')`,
  },
  {
    fontFamily: 'Jost',
    fontStyle: 'normal',
    fontDisplay: 'swap',
    fontWeight: 700,
    src: `url(${JostSemiBold}) format('truetype')`,
  },
  {
    fontFamily: 'Jost',
    fontStyle: 'normal',
    fontDisplay: 'swap',
    fontWeight: 900,
    src: `url(${JostBold}) format('truetype')`,
  },
]

const freightBigPro: any = {
  fontFamily: 'freight-pro',
  fontStyle: 'normal',
  fontDisplay: 'swap',
  fontWeight: 400,
  src: `
    url(${FreightBigPro}) format('woff2')
  `,
}
const freightBigProBold: any = {
  fontFamily: 'freight-pro',
  fontStyle: 'normal',
  fontDisplay: 'swap',
  fontWeight: 600,
  src: `
    url(${FreightBigProBold}) format('woff2')
  `,
}
const futuraPt: any = {
  fontFamily: 'futura-pt',
  fontStyle: 'normal',
  fontDisplay: 'swap',
  fontWeight: 400,
  src: `
    url(${FuturaPt}) format('woff2')
  `,
}
const futuraPtBold: any = {
  fontFamily: 'futura-pt',
  fontStyle: 'normal',
  fontDisplay: 'swap',
  fontWeight: 600,
  src: `
    url(${FuturaPtMedium}) format('woff2')
  `,
}

const merriweatherRegular: any = {
  fontFamily: 'Merriweather',
  fontStyle: 'normal',
  fontDisplay: 'swap',
  fontWeight: 400,
  src: `
    url(${MerriweatherRegular}) format('truetype')
  `,
}
const merriweatherBold: any = {
  fontFamily: 'Merriweather',
  fontStyle: 'normal',
  fontDisplay: 'swap',
  fontWeight: 600,
  src: `
    url(${MerriweatherBold}) format('truetype')
  `,
}

const styles = createStyles({
  '@global': {
    '@font-face': [
      ...JOST_FONT,
      freightBigPro,
      freightBigProBold,
      futuraPt,
      futuraPtBold,
      merriweatherRegular,
      merriweatherBold,
    ],
  },
})

const Baseline = withStyles(styles, {
  name: 'Baseline',
})(() => <CssBaseline />)
export default Baseline
